import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import './Input.scss';

class Input extends PureComponent {
  onChange = event => {
    const { value, checked } = event.target;
    this.props.onChange(this.props.type === 'checkbox' ? checked : value);
  };

  render() {
    return (
      <input
        {...this.props}
        type={this.props.type}
        value={this.props.value}
        onChange={this.onChange}
        className={`pencil-input ${this.props.className}`}
        placeholder={this.props.placeholder}
        min={0}
        step={this.props.step}
        onKeyDown={this.props.onKeyDown}
      />
    );
  }
}

Input.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  step: PropTypes.string,
  onKeyDown: PropTypes.func,
};

Input.defaultProps = {
  type: 'text',
  value: '',
  onChange: () => {},
  className: '',
  placeholder: '',
};

export default Input;
